module.exports = __webpack_public_path__ + "media/images/sessions-bg-bc341940273ea8fc2cbb195e8c7064d4.svg";